<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Confirmación</h4>
  <button type="button" class="close btn-default btn-circle" aria-label="Close" (click)="activeModal.dismiss(undefined)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <form>
    <div class="mb-3">
      <label for="message-text" class="col-form-label">Comentario:</label>
      <textarea *ngIf="financialContract" [(ngModel)]="financialContract.comment" class="form-control" id="message-text" name="message"></textarea>
      <textarea *ngIf="accountTransaction" [(ngModel)]="accountTransaction.comment" class="form-control" id="message-text" name="message"></textarea>
      <p *ngIf="showError">** El comentario es requerido ++</p>
    </div>
  </form>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger w-100 me-2 shadow-none" (click)="this.activeModal.dismiss(undefined)">Cancelar</button>
  <button type="button" class="btn btn-primary w-100 me-2 shadow-none" (click)="resolution()">{{approved ? 'Aprobar' : 'Negar'}}</button>
</div>
